import { version } from "../../package.json";
const configFunction = (defaults = {}) => ({
	version,
	...defaults,
	...window.runConfig,
});
export default configFunction;
